import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { Category } from "./Category";
import { TopicStat } from "./TopicStat";
import { User } from "./User";

export class Topic {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field()
	public createdOn?: string;

	@Field({entity: User})
	public createdBy?: User;

	@Field({entity: TopicStat})
	public stat: TopicStat;

	@Field({entity: Category})
	public category?: Category;

}

// tslint:disable:max-classes-per-file
@Entity({delete: "topicDelete"})
export class TopicDelete {

	// this is still an ActionResult

	@Field()
	public entityId: ID;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/Topic.ts